<template>
  <v-bottom-navigation
      background-color="transparent"
       dark :value="$store.getters.getExtensionMenuSelected" color="yellow"
  >
    <v-btn
        v-for="menu in $store.getters.extensionMenu"
        :key="menu.name"
        @click="$vuetify.goTo('#' + menu.name)"
        :value="menu.name"
    >
      <span>{{ menu.name }}</span>
      <v-icon>{{ menu.icon }}</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
export default {
  name: "ExtendedBtnMenu",
  data() {
    return {
      val: null
    }
  },
  computed:{
    routeHash(){
      return this.$route.hash.substring(1)
    }
  }
}
</script>

<style scoped>

</style>
